import React, { useEffect, useState } from "react";
import Table from "../../extra/Table";
import Pagination from "../../extra/Pagination";
import { connect, useDispatch, useSelector } from "react-redux";
import AttributeDialog from "./AttributeDialog";
import { warning } from "../../../util/Alert";
import dayjs from "dayjs";
import Button from "../../extra/Button";
import Iconb from "../../extra/Iconb";
import { OPEN_DIALOGUE } from "../../store/dialogue/dialogue.type";
import {
  getAttribute,
  deleteAttribute,
} from "../../store/attribute/attribute.action";
import EditInfo from "../../../assets/images/Edit.png";
import Delete from "../../../assets/images/Delete.svg"
import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined';
import DeleteIcon from '@mui/icons-material/Delete';

const Attribute = (props) => {
  const [page, setPage] = useState(0);
  const [data, setData] = useState([]);

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [expandedRows, setExpandedRows] = useState({}); // State to track expanded rows

  const handleToggle = (rowId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [rowId]: !prev[rowId], // Toggle expanded state for the clicked row
    }));
  };

  const dispatch = useDispatch();

  const { attribute } = useSelector((state) => state.attribute);
  const { dialogue, dialogueType, dialogueData } = useSelector(
    (state) => state.dialogue
  );
  

  useEffect(() => {
    dispatch(getAttribute());
  }, [dispatch]);
  useEffect(() => {
    setData(attribute);
  }, [attribute]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event, 10));
    setPage(0);
  };

  // Delete PromoCode
  const handleDelete = (id) => {
    

    const data = warning();
    data
      .then((isDeleted) => {
        if (isDeleted) {
          dispatch(deleteAttribute(id));
        }
      })
      .catch((err) => console.log(err));
  };

  const mapData = [
    {
      Header: "No",
      width: "20px",
      Cell: ({ index }) => <span className="text-white">{parseInt(index) + 1}</span>,
    },

    {
      Header: "Name",
      body: "name",
      Cell: ({ row }) => <span className="fw-normal fs-6 text-white">{row?.name}</span>,
    },

    {
      Header: "Details",
      body: "details",
      Cell: ({ row }) => {
        const [isExpanded, setIsExpanded] = useState(false);
        const detailsText = row?.value.map((condition) => (
          <span className="ms-1 text-capitalize text-white fw-normal">{condition + ","}</span>
        ));

        return (
          <div>
            {isExpanded ? detailsText : detailsText.slice(0, 5)}
            {row?.value.length > 2 && !isExpanded}
            <span
              onClick={() => setIsExpanded(!isExpanded)}
              className="pointer text-white fw-normal"
              style={{ display: "inline-block", marginLeft: "5px" }}
            >
              {isExpanded ? "Read Less..." : "Read More"}
            </span>
          </div>
        );
      },
    },
    {
      Header: "Created Date",
      body: "createdAt",
      Cell: ({ row }) => (
        <span className="text-white fw-normal">{dayjs(row?.createdAt).format("DD MMM YYYY")}</span>
      ),
    },
    {
      Header: "Edit",
      body: "",
      Cell: ({ row }) => (
        <>
          {/* <img
          src={EditInfo}
          height={25}
          width={25}
          alt="Edit"
          onClick={() =>
            dispatch({
              type: OPEN_DIALOGUE,
              payload: { data: row, type: "attribute" },
            })
          }
        /> */}
          <Iconb
            type="button"
            newClass={`themeFont boxCenter infobtn userBtn   `}
            btnIcon={<CreateOutlinedIcon sx={{ color: '#737272' }} />}
            style={{
              borderRadius: "50px",
              margin: "auto",
              height: "40px",
              width: "40px",
              color: "#160d98",
              padding: "0px"

            }}
            isImage={true}

            onClick={() =>
              dispatch({
                type: OPEN_DIALOGUE,
                payload: { data: row, type: "attribute" },
              })
            }

          />
        </>
      ),
    },
    {
      Header: "Delete",
      body: "",
      Cell: ({ row }) => (
        <>
          <Iconb
            newClass={`themeFont boxCenter killbtn userBtn `}
            btnIcon={<DeleteIcon sx={{ color: '#FF4C51' }} />}
            style={{
              borderRadius: "50px",
              margin: "auto",
              height: "40px",
              width: "40px",
              color: "#160d98",
              padding: "0px"

            }}
            isImage={true}
            isDeleted={true}
            onClick={() => handleDelete(row?._id)}

          />
          {/* <button
            className={`themeBtn text-center `}
            style={{
              borderRadius: "5px",
              margin: "auto",
              width: "40px",
              backgroundColor: "#fff",
              color: "#cd2c2c",
            }}
            onClick={() => handleDelete(row?._id)}
          >
            <svg
              width="25"
              height="25"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.04017 6L4.9258 16.6912C4.98927 17.4622 5.646 18.0667 6.41993 18.0667H14.5801C15.354 18.0667 16.0108 17.4622 16.0742 16.6912L16.9598 6H4.04017ZM7.99953 16.0667C7.7378 16.0667 7.5176 15.8631 7.501 15.5979L7.001 7.53123C6.9839 7.25537 7.19337 7.01807 7.46877 7.00097C7.7544 6.98093 7.98147 7.19287 7.99903 7.46873L8.49903 15.5354C8.51673 15.8211 8.2907 16.0667 7.99953 16.0667ZM11 15.5667C11 15.843 10.7764 16.0667 10.5 16.0667C10.2236 16.0667 10 15.843 10 15.5667V7.5C10 7.22363 10.2236 7 10.5 7C10.7764 7 11 7.22363 11 7.5V15.5667ZM13.999 7.53127L13.499 15.5979C13.4826 15.8604 13.2638 16.0791 12.9687 16.0657C12.6933 16.0486 12.4839 15.8113 12.501 15.5354L13.001 7.46877C13.0181 7.1929 13.2598 6.9922 13.5312 7.001C13.8066 7.0181 14.0161 7.2554 13.999 7.53127ZM17 3H14V2.5C14 1.67287 13.3271 1 12.5 1H8.5C7.67287 1 7 1.67287 7 2.5V3H4C3.4477 3 3 3.4477 3 4C3 4.55223 3.4477 5 4 5H17C17.5523 5 18 4.55223 18 4C18 3.4477 17.5523 3 17 3ZM13 3H8V2.5C8 2.22413 8.22413 2 8.5 2H12.5C12.7759 2 13 2.22413 13 2.5V3Z"
                fill="#CD2C2C"
              />
            </svg>
          </button> */}
        </>
      ),
    },

    // add more columns as needed
  ];

  return (
    <>
      <div className="mainSellerTable">
        <div className="sellerTable">
          <div className="col-12 headname">Attribute </div>
          <div className="sellerMain">

            <div className="tableMain mt-2">
              <div className="row">
                <div className="col-12" style={{ margin: "12px" }}>
                  <Button
                    newClass={`whiteFont`}
                    btnColor={`btnBlackPrime `}
                    btnIcon={`fa-solid fa-plus text-dark`}
                    btnName={`Add`}
                    onClick={() => {
                      dispatch({
                        type: OPEN_DIALOGUE,
                        payload: { type: "attribute" },
                      });
                    }}
                    style={{ borderRadius: "5px", padding: "8px 32px", background: "#fff" }}
                  />
                  {dialogue && dialogueType === "attribute" && (
                    <AttributeDialog />
                  )}
                </div>

              </div>
              <Table
                data={data}
                mapData={mapData}
                PerPage={rowsPerPage}
                Page={page}
                type={"client"}
              />
              {/* <Pagination   //Pagination if need
                component="div"
                count={attribute?.length}
                serverPage={page}
                type={"client"}
                onPageChange={handleChangePage}
                serverPerPage={rowsPerPage}
                totalData={attribute?.length}
                onRowsPerPageChange={handleChangeRowsPerPage}
              /> */}
            </div>
          </div>
          <div className="sellerFooter primeFooter"></div>
        </div>
      </div>
    </>
  );
};

export default connect(null, { getAttribute, deleteAttribute })(Attribute);
